import { DEMO_PORTFOLIO_ID } from '@/constants';

// Move the demo check to here to centralize the check logic
export const isDemoPortfolio = (portfolioId: string) =>
  portfolioId === DEMO_PORTFOLIO_ID;
